var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { calculateEventFlow, calculateGameScore, } from "../../../services/sosyoley.services";
import { eventMapping, eventUpdateSubject, marketMapping } from "../../../store/sportsbook.store";
import { dateTimeFormat, getCouponStatus, useForceUpdate } from "../../../lib/misc.functions";
import { addToBetSlip } from "../../../services/betslip.services";
import { statusIcon } from "../../../definitions/constants/coupon-status-constant";
import { useEffect } from "react";
import { betSlipActionSubject } from "../../../store/betslip.store";
import { Link } from "react-router-dom";
import { LiveScoreStatusType } from "../../../definitions/constants/event-status-type.constant";
import { marketNameTransform } from "../../../services/sportsbook.services";
import { handicappedMarkets } from "../../../definitions/constants/market-categories.constant";
import { eventEndedStatuses } from "../../../definitions/constants/event-result-type";
var updateTimer;
export function CouponEventRow(props) {
    var _a, _b, _c;
    var forceUpdate = useForceUpdate();
    var post = props.post;
    var row = props.row;
    var sbEvent;
    var sbMarket;
    var sbOutcome;
    var outcome;
    var market;
    var gameScore;
    var event = props.event;
    // console.log(event)
    if (event) {
        if (props && props.event && props.event.eventId && eventMapping[props.event.eventId]) {
            event.matchPlayTime = eventMapping[props.event.eventId].matchPlayTime;
            // event.markets = marketMapping[props.event.eventId];
            event.scores = eventMapping[props.event.eventId].scores;
        }
        if (event.scores && event.matchPlayTime) {
            var eventFlow = calculateEventFlow(event.scores.statusId, event.matchPlayTime, Number(event.sportId));
            if (eventFlow) {
                event['minute'] = eventFlow.minute;
                event['shortName'] = eventFlow.shortName;
            }
        }
        // console.log(row)
        // console.log(event)
        var availableMarkets = marketMapping[String(props.event.eventId)];
        // console.log(availableMarkets)
        if (availableMarkets) {
            market = availableMarkets.find(function (m) { return Number(m.marketId) === Number(row.market_id); });
        }
        if (!market || market === undefined) {
            market = event.markets.find(function (m) { return Number(m.marketId) === Number(row.market_id); });
        }
        if (market) {
            //console.log("market", market.specialOddsValue)
            market.marketOutcome ? outcome = market.marketOutcome.find(function (el) { return Number(el.outcomeNo) === Number(row.outcome_no); }) : null;
            sbEvent = eventMapping[event.eventId.toString()];
            if (sbEvent) {
                sbMarket = marketMapping[event.eventId].find(function (m) { return m.marketName === market.marketName; });
                // sbMarket = marketIdMapping[event.eventId][market.marketId]
                // console.log(sbMarket)
                if (sbMarket && (sbMarket.marketStatus < 0 || sbMarket.marketStatus === 1)) {
                    sbOutcome = sbMarket.marketOutcome.find(function (o) { return Number(o.outcomeNo) === Number(outcome.outcomeNo); });
                    row['playableObject'] = { sbEvent: sbEvent, sbMarket: sbMarket, sbOutcome: sbOutcome };
                    if (post.coupon) {
                        post.coupon["playable"] = true;
                    }
                }
            }
            // console.log(outcome)
            if (outcome) {
                var _d = getCouponStatus(event, market, outcome), oleyOutcomeResult = _d.oleyOutcomeResult, eventStatus = _d.eventStatus, iconStatus = _d.iconStatus, shortName = _d.shortName;
                // console.log(oleyOutcomeResult, eventStatus, iconStatus, shortName)
                event.shortName = shortName;
                event.iconStatus = iconStatus;
                event.eventStatus = eventStatus;
                event.oleyOutcomeResult = oleyOutcomeResult;
                // console.log(event)
            }
        }
        gameScore = calculateGameScore(event);
    }
    var getMatchStatus = function () {
        try {
            if (event.officialScore && event.officialScore.find(function (e) { return e.scoreTypeName === 'AP'; })) {
                return 'PEN';
            }
            if (event.officialScore && event.officialScore.find(function (e) { return e.scoreTypeName === 'OT'; })) {
                return 'UZ';
            }
            if (event.matchStatus === 'ended') {
                return 'MS';
            }
            else if (event.officialScore && event.officialScore.find(function (e) { return e.scoreTypeName === 'FT'; })) {
                return 'MS';
            }
            if (event.scores && event.scores.status === 'FT') {
                return 'MS';
            }
            else if (event.eventObject && event.eventObject.liveScoreStatus) {
                var time_statuses = ["520", "521", "522", "523", "700"];
                if (time_statuses.includes(event.eventObject.liveScoreStatus.toString())) {
                    return "<span class=\"minute\">".concat(event.eventObject.matchPlayTime, "'</span>");
                }
                else {
                    return "<span class=\"minute\">".concat(LiveScoreStatusType[Number(event.eventObject.liveScoreStatus)], "</span>");
                }
            }
        }
        catch (e) {
            console.log(e);
        }
        return '';
    };
    var quarterMap = {
        '1. Çeyrek': 'first',
        '2. Çeyrek': 'second',
        '3. Çeyrek': 'third',
        '4. Çeyrek': 'fourth'
    };
    var whichMarketQuarter = function (row, event) {
        if (row.market_name && event.scores) {
            var quarterKey = Object.keys(quarterMap).find(function (key) { return row.market_name.includes(key); });
            if (quarterKey) {
                var quarterNumber = quarterKey.split('.')[0];
                var quarterPeriod = quarterMap[quarterKey];
                var quarterScore = "".concat(quarterNumber, "\u00C7 ").concat(event.scores.homeTeam.periods[quarterPeriod], ":").concat(event.scores.awayTeam.periods[quarterPeriod]);
                return quarterScore;
            }
            else
                return ('');
        }
        return ('');
    };
    useEffect(function () {
        var betSlipActionSubject_subscription = betSlipActionSubject.subscribe(function (events) {
            if (typeof events === 'object' && event) {
                if (['toggle', 'remove'].includes(events.action)) {
                    if (events.betSlip.sportEvent) {
                        if (events.betSlip.sportEvent.eventId === event.eventId) {
                            forceUpdate();
                        }
                    }
                }
                else if (events.action === 'clear') {
                    if (events.betSlip.includes(event.eventId)) {
                        forceUpdate();
                    }
                }
            }
        });
        var eventUpdateSubject_subscription = eventUpdateSubject.subscribe(function (events) {
            if (event && (events.includes(event.eventId))) {
                clearTimeout(updateTimer);
                updateTimer = setTimeout(function () {
                    forceUpdate();
                }, 300);
            }
        });
        return function () {
            betSlipActionSubject_subscription.unsubscribe();
            eventUpdateSubject_subscription.unsubscribe();
            clearTimeout(updateTimer);
        };
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs("td", __assign({ width: 32, className: "text-center" }, { children: [_jsx("div", { className: "icon game-event-icon mb-1 " + ((_a = event === null || event === void 0 ? void 0 : event.sportSlug) === null || _a === void 0 ? void 0 : _a.toLowerCase()), style: { width: 18, height: 18 } }, void 0), _jsx("div", __assign({ className: "mbs mbs-".concat(row.mbs) }, { children: row.mbs }), void 0), row.banker ?
                        _jsx("div", __assign({ className: "btn banker " + (row.banker ? 'selected' : '') }, { children: "B" }), void 0) : _jsx(_Fragment, {}, void 0)] }), void 0), _jsxs("td", __assign({ className: "text-left" }, { children: [_jsx("div", __assign({ className: "event-info" }, { children: _jsx("div", __assign({ className: "event-name" }, { children: event ? _jsx(_Fragment, { children: _jsx(Link, __assign({ to: '/iddaa/' + event.sportSlug + '/tumu/' + event.competitionId + '/' + event.eventId }, { children: row.event_name }), void 0) }, void 0) : _jsx(_Fragment, { children: _jsx(Link, __assign({ to: '/iddaa/' + ((_b = row.event_type) === null || _b === void 0 ? void 0 : _b.toLowerCase()) + '/tumu/0/' + row.event_id }, { children: row.event_name }), void 0) }, void 0) }), void 0) }), void 0), _jsxs("div", __assign({ className: "event-date" }, { children: [_jsx("div", __assign({ className: "float-left" }, { children: dateTimeFormat(row.event_date) }), void 0), row.is_live_event ? _jsx("div", __assign({ className: "float-left live ml-1" }, { children: "Canl\u0131" }), void 0) : _jsx(_Fragment, {}, void 0)] }), void 0), _jsx("div", { className: "clearfix" }, void 0), _jsxs("div", __assign({ className: "market visible-sm" }, { children: [_jsxs("div", __assign({ className: "market-name" }, { children: [row.market_name.replace('Toplam', 'Top'), outcome ?
                                        _jsxs("b", { children: [_jsx("br", {}, void 0), outcome.outcomeName, " ", market ? (handicappedMarkets.includes(market.marketType + '-' + market.marketSubType) ? marketNameTransform('', market.specialOddsValue, market) : '') : ('')] }, void 0) : _jsx(_Fragment, {}, void 0)] }), void 0), _jsx("div", __assign({ className: "outcome" }, { children: sbEvent && sbMarket && sbOutcome ? _jsx("button", __assign({ className: "btn btn-odds ".concat(sbOutcome.isUpdated, " added-").concat(sbOutcome.isSelected, " ") + (sbMarket.marketStatus < 0 ? 'locked' : ''), onClick: function () {
                                        addToBetSlip(sbEvent, sbMarket, sbOutcome);
                                    } }, { children: _jsx("div", __assign({ className: "ratio text-center" }, { children: Number(row.fixed_odds_web).toFixed(2) }), void 0) }), void 0) : _jsx(_Fragment, { children: _jsx("div", __assign({ className: "text-right" }, { children: Number(row.fixed_odds_web).toFixed(2) }), void 0) }, void 0) }), void 0)] }), void 0)] }), void 0), _jsx("td", __assign({ className: "hidden-sm text-left" }, { children: row.market_name }), void 0), _jsx("td", __assign({ className: "hidden-sm" }, { children: sbEvent && sbMarket && sbOutcome ? _jsxs("button", __assign({ className: "btn btn-odds ".concat(sbOutcome.isUpdated, " added-").concat(sbOutcome.isSelected, " ") + (sbMarket.marketStatus < 0 ? 'locked' : ''), onClick: function () {
                        addToBetSlip(sbEvent, sbMarket, sbOutcome);
                    } }, { children: [_jsx("div", __assign({ className: "outcome-name" }, { children: marketNameTransform(sbOutcome.outcomeName, sbMarket.specialOddsValue, sbMarket) }), void 0), _jsx("div", __assign({ className: "ratio text-right" }, { children: Number(row.fixed_odds_web).toFixed(2) }), void 0)] }), void 0) : _jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "float-left ml-2" }, { children: [row.outcome_display, " ", market ? (handicappedMarkets.includes(market.marketType + '-' + market.marketSubType) ? marketNameTransform('', market.specialOddsValue, market) : '') : ('')] }), void 0), _jsx("div", __assign({ className: "float-right mr-2" }, { children: Number(row.fixed_odds_web).toFixed(2) }), void 0)] }, void 0) }), void 0), _jsxs("td", __assign({ className: "hidden-sm" }, { children: [gameScore, _jsx("br", {}, void 0), event && event.sportId && Number(event.sportId) === 2 ?
                        _jsx("div", __assign({ className: 'font-weight-bold fs-small' }, { children: whichMarketQuarter(row, event) }), void 0) : ''] }), void 0), event && eventEndedStatuses.indexOf(event.liveScoreStatus) == -1 ? _jsxs("td", __assign({ width: 55, className: "scores" }, { children: [event && event.minute && Number(event.minute) !== 0 ?
                        _jsx("div", __assign({ className: "minute" }, { children: event.minute }), void 0) : _jsx(_Fragment, { children: event ? (event.matchPlayTime ? "".concat(event.matchPlayTime, "'") : event.shortName) : 'Bşl' }, void 0), gameScore ? _jsx(_Fragment, { children: _jsxs("div", __assign({ className: "visible-sm" }, { children: [_jsx("span", __assign({ style: {
                                        fontSize: 15,
                                        fontStyle: 'Normal',
                                        fontWeight: 700
                                    } }, { children: gameScore.split('/')[1] ? gameScore.split('/')[1] : gameScore.split('/')[0] }), void 0), _jsx("br", {}, void 0), [4, 5, 20, 23].includes(Number(event.sportId)) ? null :
                                    _jsxs("i", __assign({ style: {
                                            fontSize: 12,
                                            fontStyle: 'Normal',
                                            fontWeight: 400
                                        } }, { children: ["\u0130Y ", gameScore.split('/')[0]] }), void 0), event && event.sportId && Number(event.sportId) === 2 ?
                                    _jsx("div", __assign({ style: { fontSize: 12 } }, { children: whichMarketQuarter(row, event) }), void 0) : ''] }), void 0) }, void 0) : _jsx(_Fragment, { children: _jsx("div", __assign({ className: "visible-sm" }, { children: event && _jsxs(_Fragment, { children: [(_c = event.matchPlayTime) !== null && _c !== void 0 ? _c : '', "' ", getMatchStatus()] }, void 0) }), void 0) }, void 0), _jsx("div", __assign({ className: "visible-sm" }, { children: event ? _jsx("img", { src: statusIcon[event.iconStatus] }, void 0) :
                            _jsx("img", { src: statusIcon[0] }, void 0) }), void 0)] }), void 0) : _jsx("td", __assign({ width: 55, className: "scores" }, { children: getMatchStatus() }), void 0), _jsx("td", __assign({ className: "hidden-sm" }, { children: event ? _jsx("img", { src: statusIcon[event.iconStatus] }, void 0) : _jsx("img", { src: statusIcon[0] }, void 0) }), void 0)] }, void 0));
}
